import {RutsolveToken} from "@/storage/rutsolve_token"

export class File {
    public static async read(url: string): Promise<string> {
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": RutsolveToken.read()
                }
            })
            const blob = await response.blob()
            return await this.extract(blob)
        } catch(error) {
            console.error(error)
            return null
        }
    }

    private static async extract(input: Blob): Promise<string> {
        const promise: Promise<string> = new Promise((resolve) => {
            const reader = new FileReader()
            reader.onload = (event) => {
                resolve(event.target.result.toString())
            }
            reader.readAsDataURL(input)
        })
        return await promise
    }
}
